import {useState, useEffect} from 'react';
import {useHistory, useLocation} from "react-router-dom";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ClassOutlinedIcon from '@mui/icons-material/ClassOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';

const tabStyles = {
  width: "100%",
  display: {xs: "flex", sm: "flex", md: "none"},
  position: "absolute",
  bottom: 0,
  justifyContent: "center",
  background: "#F2F2F2",
  borderRadius: "5px 5px 0px 0px",
  color: "#EA5B13",
  zIndex: 100
}

const regExProfile = /perfil/;
const regExEmployees = /personal/;
const regExBusiness = /negocio./;
const regExChat = /chat/;

export default function TabMenu() {
  const [value, setValue] = useState(3);
  const history = useHistory();
  const { pathname: currentPath} = useLocation();

  useEffect(() => {
    if (regExProfile.test(currentPath)) {
      setValue(1);
    }else if(regExEmployees.test(currentPath)){
      setValue(2);
    }else if(regExBusiness.test(currentPath)){
      setValue(3);
    }else if(regExChat.test(currentPath)){
      setValue(4);
    }
  }, [currentPath]);


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Tabs sx={tabStyles} variant="fullWidth" value={value} onChange={handleChange} aria-label="icon tab" indicatorColor='secondary' textColor='secondary' centered>
      <Tab value={1} icon={<PersonOutlineOutlinedIcon/>} aria-label="person" onClick={() => history.push("/perfil")}/>
      <Tab value={2} icon={<ClassOutlinedIcon/>} aria-label="album" onClick={() => history.push("/personal/repartidores")} />
      <Tab value={3} icon={<StorefrontOutlinedIcon/>} aria-label="store" onClick={() => history.push("/negocios")}/>
      <Tab value={4} icon={<ChatBubbleOutlineOutlinedIcon/>} aria-label="chat" onClick={() => history.push("/chat")}/>
    </Tabs>
  );
}